import { render, staticRenderFns } from "./admin-accessLogs.vue?vue&type=template&id=1a2fceb4&"
import script from "./admin-accessLogs.vue?vue&type=script&lang=js&"
export * from "./admin-accessLogs.vue?vue&type=script&lang=js&"
import style0 from "./admin-accessLogs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports